var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrameenLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 304.547,
    height: 71.639,
    viewBox: "0 0 304.547 71.639",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grameen-logo",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(86.928 14.861)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M89.58,25.7h5.41V36.324a20.458,20.458,0,0,1-11.213,3.594c-8.37,0-14.727-6.081-14.727-14.1,0-7.976,6.473-14.017,15.082-14.017a17.416,17.416,0,0,1,11.095,4.029l-3.514,4.461a11.568,11.568,0,0,0-7.581-3.08,8.628,8.628,0,1,0,.039,17.255,12.575,12.575,0,0,0,5.41-1.5Z",
    transform: "translate(-69.05 -11.804)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M102.2,26.491h5.765c3.433,0,5.407-1.579,5.407-4.737,0-3.081-1.974-4.62-5.407-4.62H102.2ZM112.934,39.6l-4.384-7.9H102.2v7.9H95.959V11.961h12c7.223,0,11.331,3.475,11.331,9.595,0,4.264-1.818,7.343-5.174,8.922L120,39.6Z",
    transform: "translate(-62.083 -11.763)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M137.453,29.215l-4.344-10.74-4.382,10.74Zm2.012,5.015H126.675L124.5,39.6h-6.435l12-27.639H136.5L148.31,39.6h-6.674Z",
    transform: "translate(-56.358 -11.764)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M152.9,11.962l8.055,16.9,8.013-16.9h6.95V39.6h-5.606V20.964L162.97,36.8H158.9l-7.343-15.832V39.6h-5.645V11.962Z",
    transform: "translate(-49.148 -11.763)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M197.16,11.962v5.172H182.351v6H195.66v5.172H182.351v6.121h15.242V39.6H176.116V11.962Z",
    transform: "translate(-41.329 -11.763)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M220.46,11.962v5.172H205.653v6H218.96v5.172H205.653v6.121h15.241V39.6H199.416V11.962Z",
    transform: "translate(-35.296 -11.763)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M227.714,11.962l13.425,17.767V11.962h5.921V39.6h-5.686L227.99,21.873V39.6h-5.961V11.962Z",
    transform: "translate(-29.441 -11.763)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M83.207,40.273l-.022,2.381H75.3v4.534h7.14v2.357H75.3v6.444H72.657V40.273Z",
    transform: "translate(-68.116 -4.433)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M89.749,48.144a5.635,5.635,0,0,0,5.658,5.591,5.569,5.569,0,1,0-5.658-5.591m13.964,0a8.339,8.339,0,1,1-8.33-7.926,8.042,8.042,0,0,1,8.33,7.926",
    transform: "translate(-64.388 -4.447)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M114.2,53.72a3.87,3.87,0,0,0,4.152-4.244v-9.2h2.651v9.2c0,4.109-2.581,6.623-6.825,6.623s-6.848-2.514-6.848-6.623v-9.2h2.649v9.2a3.922,3.922,0,0,0,4.22,4.244",
    transform: "translate(-59.137 -4.433)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M129.737,40.273l8.419,11.294V40.273h2.6V55.988h-2.6l-8.376-11.27v11.27h-2.648V40.273Z",
    transform: "translate(-54.012 -4.433)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M159.416,48.153a5.357,5.357,0,0,0-5.5-5.5h-3.75V53.607h3.861a5.267,5.267,0,0,0,5.388-5.455m2.673-.022c0,4.534-3.436,7.856-8.2,7.856h-6.375V40.273h6.442c4.716,0,8.129,3.3,8.129,7.857",
    transform: "translate(-48.733 -4.433)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M175.552,50.082,172.59,43.1l-2.964,6.981Zm1.01,2.358h-7.924l-1.5,3.546h-2.761l6.938-15.715h2.715L180.9,55.987h-2.832Z",
    transform: "translate(-44.369 -4.433)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M194.183,40.273v2.381H189.2V55.988H186.55V42.654h-4.96V40.273Z",
    transform: "translate(-39.911 -4.433)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M199.532,55.988h2.649V40.273h-2.649Z",
    transform: "translate(-35.266 -4.433)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M212.868,48.144a5.636,5.636,0,0,0,5.658,5.591,5.569,5.569,0,1,0-5.658-5.591m13.964,0a8.339,8.339,0,1,1-8.328-7.926,8.042,8.042,0,0,1,8.328,7.926",
    transform: "translate(-32.511 -4.447)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M233.128,40.273l8.419,11.294V40.273h2.6V55.988h-2.6l-8.374-11.27v11.27h-2.649V40.273Z",
    transform: "translate(-27.242 -4.433)",
    fill: "#007b91",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M63.927,29.781A35.86,35.86,0,0,0,29.781,63.928,35.861,35.861,0,0,0,63.927,29.781",
    transform: "translate(7.711 7.711)",
    fill: "#689431",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M0,29.781A35.861,35.861,0,0,0,34.147,63.928,35.86,35.86,0,0,0,0,29.781",
    transform: "translate(0 7.711)",
    fill: "#ed680f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M34.147,0A35.86,35.86,0,0,0,0,34.146,35.86,35.86,0,0,0,34.147,0",
    transform: "translate(0)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M58.715,13.911A11.138,11.138,0,1,1,47.577,2.772,11.138,11.138,0,0,1,58.715,13.911",
    transform: "translate(9.434 0.718)",
    fill: "#8c2984",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrameenLogo);
export default __webpack_public_path__ + "static/media/grameen-logo.abb61ef7f14701389a8137699ef3e801.svg";
export { ForwardRef as ReactComponent };